import parse from "html-react-parser";

const HtmlToReact = parse;

export {
    HtmlToReact
};
